/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on
 * an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { ReactNode } from 'react';
import { PopoverProps } from 'antd/lib/popover';
import { ControlComponentProps } from '@superset-ui/chart-controls';

export enum TEXT_COMPARATOR {
  EQUALS = '等于',
  CONTAINS = '包含',
  STARTS_WITH = '开始于',
  ENDS_WITH = '结束于',
}

export interface TextColorRule {
  column?: string;
  operator: TEXT_COMPARATOR;
  targetValue: string;
  colorScheme: string;
  customColor?: { r: number; g: number; b: number; a: number };
}

export type TextColorFormattingControlProps = ControlComponentProps<
  TextColorRule[]
> & {
  columnOptions: { label: string; value: string }[];
  removeIrrelevantConditions: boolean;
  verboseMap: Record<string, string>;
  label: string;
  description: string;
};

export type TextFormattingPopoverProps = PopoverProps & {
  columns: { label: string; value: string }[];
  onChange: (value: TextColorRule) => void;
  config?: TextColorRule;
  title: string;
  children: ReactNode;
};
